import { render, staticRenderFns } from "./group-list.vue?vue&type=template&id=bb0156fc&scoped=true&lang=pug"
import script from "./group-list.vue?vue&type=script&lang=js"
export * from "./group-list.vue?vue&type=script&lang=js"
import style0 from "./group-list.vue?vue&type=style&index=0&id=bb0156fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb0156fc",
  null
  
)

export default component.exports